import { Component } from "@angular/core"
import { NgbModal } from "@ng-bootstrap/ng-bootstrap"
import { CookiesService } from "../../services/cookies.service"
import { UserService } from "../../services/user.service"
import { LocalizationModalComponent } from "../modals/localization-modal/localization-modal.component"

@Component({
    selector: "app-confirm-station",
    templateUrl: "./confirm-station.component.html",
    styleUrls: ["./confirm-station.component.less"],
})
export class ConfirmStationComponent {
    show = false
    confirmStationCookie = null
    callsignCookie = null

    constructor(
        private cookieService: CookiesService,
        public userService: UserService,
        private modalService: NgbModal
    ) {
        this.confirmStationCookie = this.cookieService.getCookie("station_confirmed")
        this.callsignCookie = this.cookieService.getCookie("organization_callsign")
        this.show =
            !this.userService.isLoggedIn() &&
            !(this.confirmStationCookie && this.confirmStationCookie.value == "true")
    }

    confirmStation() {
        let hostName = window.location.hostname
        let domain = hostName.substring(hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1))

        this.cookieService.setCookie("station_confirmed", "true", 365, domain)
        this.show = false
    }

    dismiss() {
        this.show = false
    }

    openChooseStationModal() {
        this.show = false
        const modalRef = this.modalService.open(LocalizationModalComponent)
    }
}
